import { type ServiceSection } from "./types";
import { visagisteService } from "./services/visagiste";
import { colorationVegetaleService } from "./services/coloration-vegetale";
import { headSpaService } from "./services/head-spa";
import { soireesAThemesService } from "./services/soirees-a-themes";

export interface Services {
  visagiste: ServiceSection;
  colorationVegetale: ServiceSection;
  headSpa: ServiceSection;
  soireesAThemes: ServiceSection;
}

export const ServicesContent: Services = {
  visagiste: visagisteService,
  colorationVegetale: colorationVegetaleService,
  headSpa: headSpaService,
  soireesAThemes: soireesAThemesService,
};
